import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Search, Menu, X, Home } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const STATIC_LINKS = [
  { to: "/podcast", label: "Podcast", id: "podcast" },
  { to: "/magazine", label: "Magazine", id: "magazine" },
  { to: "/chronique", label: "Chronique de la semaine", id: "chronique" },
  { to: "/a-propos", label: "À propos", id: "apropos" },
];

export const MainNav = () => {
  const { navCategories } = useSettings();
  const LINKS = [...navCategories.map((c) => ({ to: `/rubrique/${c.slug}`, label: c.name, id: c.slug })), ...STATIC_LINKS];
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) { navigate(`/recherche?q=${encodeURIComponent(q.trim())}`); setSearchOpen(false); setOpen(false); }
  };

  return (
    <nav data-testid="main-nav" className="bg-red-600 text-white sticky top-0 z-40 shadow-md">
      <div className="container-site flex items-center">
        <NavLink to="/" end data-testid="nav-link-home" className={({ isActive }) => `nav-link flex items-center ${isActive ? "active" : ""}`}><Home size={16} /></NavLink>
        <div className="hidden lg:flex flex-1">
          {LINKS.map((l) => (
            <NavLink key={l.id} to={l.to} data-testid={`nav-link-${l.id}`} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>{l.label}</NavLink>
          ))}
        </div>
        <div className="flex-1 lg:hidden" />
        <button data-testid="nav-search-toggle" onClick={() => setSearchOpen((s) => !s)} aria-label="Rechercher" className="w-12 h-12 flex items-center justify-center hover:bg-red-800 transition-colors">
          {searchOpen ? <X size={18} /> : <Search size={18} />}
        </button>
        <button data-testid="nav-mobile-toggle" onClick={() => setOpen((s) => !s)} aria-label="Menu" className="lg:hidden w-12 h-12 flex items-center justify-center hover:bg-red-800 transition-colors">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {searchOpen && (
        <form onSubmit={submit} className="bg-red-700 border-t border-red-800">
          <div className="container-site py-3 flex gap-2">
            <input data-testid="nav-search-input" autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un article…" className="flex-1 h-10 px-3 text-[#0F172A] bg-white outline-none focus:ring-2 focus:ring-[#111827]" />
            <button data-testid="nav-search-submit" className="h-10 px-5 bg-[#111827] font-bold text-sm uppercase hover:bg-black transition-colors">OK</button>
          </div>
        </form>
      )}
      {open && (
        <div className="lg:hidden bg-red-700 border-t border-red-800">
          {LINKS.map((l) => (
            <NavLink key={l.id} to={l.to} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${l.id}`} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>{l.label}</NavLink>
          ))}
        </div>
      )}
    </nav>
  );
};
